import { logEvent } from 'firebase/analytics';
import { analytics } from '../firebase/Init';
import { getStoredUtmParams } from './utm';

// The single client-side event entry point.
//
// WHY IT IS THIS DEFENSIVE
// Firebase Analytics defines window.gtag only as a side effect of loading
// googletagmanager.com — an origin every ad blocker kills. In this product the
// #1 market is Russia, so a large share of sessions never load it. When that
// happens `analytics` can be undefined and logEvent throws, and the old call
// sites let that throw escape into the render path that triggered them.
//
// So: never throw, ever. Analytics is strictly best-effort and must never
// affect what the user sees or block a navigation.
//
// SCOPE — client events are DIRECTIONAL, NOT DECISIONAL.
// Neither Phase 0 kill gate is measured here. Affiliate CTR comes from the
// server-side affiliate_clicks ledger written by the /go/ redirect, and 30-day
// return is derived from the scans collection. Those are immune to ad blockers.
// Anything logged through this module is diagnostic colour (where people drop
// off before submitting) and it is fine that it undercounts.
//
// Keeping a client echo of affiliate_click is deliberate: comparing it with the
// server-side count is a free estimate of our ad-block rate.
export function track(eventName, params = {}) {
  try {
    if (!analytics) return false;
    logEvent(analytics, eventName, { ...params, ...getStoredUtmParams() });
    return true;
  } catch (_err) {
    // Swallowed on purpose — see above.
    return false;
  }
}

export default track;
